import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";
import { IPartnerSalesState } from "./types";

const selectBase = createSelector(
    (state: RootState) => state,
    (state) => state.partnerStatistics
)

export const selectPartnersStatisticsLoading = createSelector(
    selectBase,
    (state: IPartnerSalesState) => state.isStatisticsLoading
)

export const selectPartnerStatisticsFirstLoad = createSelector(
    selectBase,
    (state: IPartnerSalesState) => state.isStatisticsFirstLoad
)

export const selectPartnersStatisticsError = createSelector(
    selectBase,
    (state: IPartnerSalesState) => state.statisticsError
)

export const selectPartnersStatisticsAggregates = createSelector(
    selectBase,
    (state: IPartnerSalesState) => state.statistics
)

export const selectPartnerDiscountAggregates = createSelector(
    selectBase,
    (state: IPartnerSalesState) => state.discountAggregates
)

export const selectPartnerDiscountAggregatesError = createSelector(
    selectBase,
    (state: IPartnerSalesState) => state.discountAggregatesError
)

export const selectPartnerDiscountAggregatesLoading = createSelector(
    selectBase,
    (state: IPartnerSalesState) => state.isDiscountAggregatesLoading
)

export const selectPartnerDiscountAggregatesFirstLoad = createSelector(
    selectBase,
    (state: IPartnerSalesState) => state.isDiscountAggregatesFirstLoad
)

export const selectMonthlyStatisticsFirstLoad = createSelector(
    selectBase,
    (state: IPartnerSalesState) => state.isMonthlyStatisticsFirstLoad
)

export const selectMonthlyStatisticsLoading = createSelector(
    selectBase,
    (state: IPartnerSalesState) => state.isMonthlyStatisticsLoading
)

export const selectMonthlyStatisticsError = createSelector(
    selectBase,
    (state: IPartnerSalesState) => state.monthlyStatisticsError
)

export const selectMonthlyStatistics = createSelector(
    selectBase,
    (state: IPartnerSalesState) => state.monthlyStatistics
)

export const selectDailyStatisticsFirstLoad = createSelector(
    selectBase,
    (state: IPartnerSalesState) => state.isDailyStatisticsFirstLoad
)

export const selectDailyStatisticsLoading = createSelector(
    selectBase,
    (state: IPartnerSalesState) => state.isDailyStatisticsLoading
)

export const selectDailyStatisticsError = createSelector(
    selectBase,
    (state: IPartnerSalesState) => state.dailyStatisticsError
)

export const selectDailyStatistics = createSelector(
    selectBase,
    (state: IPartnerSalesState) => state.dailyStatistics
)
export const selectCurrentPartner = createSelector(
    selectBase,
    (state: IPartnerSalesState) => state.selectedPartners
)
export const selectStartDate = createSelector(
    selectBase,
    (state: IPartnerSalesState) => state.startDate
)
export const selectEndDate = createSelector(
    selectBase,
    (state: IPartnerSalesState) => state.endDate
)